<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e70">
<p class="h3" id="d41151211"><b>HOW TO</b></p>
<p class="h3" id="d41151212"><b>ROB AN</b></p>
<p class="h3" id="d41151213"><b>ARMORED</b></p>
<p class="h3" id="d41151214"><b>CAR </b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap2_howtorob_9781569477113_epub_part2.vue?61ca67df